import {
  WORK_ORDERS_CREATION_WO_CANCELLATION_MODAL_CLOSE,
  WORK_ORDERS_CREATION_WO_CANCELLATION_MODAL_SHOW,
} from '../action-types';
import { baseRoutePath } from '../work-orders';
import { push } from 'react-router-redux';

export function closeWOCancellationModal() {
  return {
    type: WORK_ORDERS_CREATION_WO_CANCELLATION_MODAL_CLOSE,
  };
}

export function goToClientSelection() {
  return (dispatch) => {
    dispatch(push(baseRoutePath + '/client-selection'));
  };
}

export function goToSubContractorsUnionTrades() {
  return (dispatch) => {
    dispatch(push(baseRoutePath + '/sub-contractors-union-trades'));
  };
}

export function goToSummary() {
  return (dispatch) => {
    dispatch(push(baseRoutePath + '/work-order-summary'));
  };
}

export function goToTasks() {
  return (dispatch) => {
    dispatch(push(baseRoutePath + '/tasks'));
  };
}

export function goToWorkingHours() {
  return (dispatch) => {
    dispatch(push(baseRoutePath + '/working-hours'));
  };
}

export function showWOCancellationModal() {
  return {
    type: WORK_ORDERS_CREATION_WO_CANCELLATION_MODAL_SHOW,
  };
}



// WEBPACK FOOTER //
// ./src/actions/admin/work-orders/creation/creation.js